<template>
  <div>
    <a-card title="付款">
      <a-row :gutter="16">

        <a-col :span="20" :md="8" :xl="6" style="max-width: 256px;">
          <a-input-search v-model="searchForm.search" placeholder="单号" allowClear @search="search" />
        </a-col>
        <a-col :span="10" :md="8" :xl="6" style="max-width: 256px;">
          <a-select placeholder="选择供应商" style="width: 100%;" allowClear @change="handleSupplierChange">
            <a-select-option v-for="supplier in supplierOptions" :key="supplier" :value="supplier">
              {{ supplier }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7">
          <a-month-picker style="width: 100px;margin-right: 12px" valueFormat="YYYY-MM" :format="'YYYY-MM'"
            :defaultValue="defaultMonth" @change="onChangePicker" placeholder="选择月份" />
          <a-button type="primary" @click="onExport">导出</a-button>

        </a-col>

        <a-col :span="4">
          <div>合计金额总和：{{ filteredTotalAmount.toFixed(2) }}</div>
        </a-col>
        <a-col :span="3" style="float: right;">
          <a-button type="primary" icon="plus" @click="handelAdd(form)">新增付款单</a-button>
        </a-col>

      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="filteredItems" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange" :scroll="{ x: 1500, y: 575 }">
          <div slot="allAmount" slot-scope="value, item">
            {{ calculate(item.payment_account_items) }}
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group size="small">
              <a-button size="small" @click="detial(item)">详情</a-button>
              <a-popconfirm title="确定作废吗?" @confirm="voidItem(item)">
                <a-button type="danger" :disabled="item.is_void">{{ item.is_void ? '已作废' : '作废' }}</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { paymentOrdersList, paymentOrdersVoid } from '@/api/finance'
import { ChangePicker } from "@/utils/excel";

export default {
  name: 'SaleRecord',
  components: {
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
          width: 45
        },
        {
          title: '单号',
          dataIndex: 'number',
          sorter: true,
          width: 150,

        },
        {
          title: '供应商',
          dataIndex: 'supplier_name',
          width: 200,
        },
        {
          title: '录入时间',
          dataIndex: 'create_time',
          width: 170,

        },
        {
          title: '发生日期',
          dataIndex: 'handle_time',
          width: 100
        },
        {
          title: '优惠金额',
          dataIndex: 'discount_amount',
          width: 80,

        },
        {
          title: '合计金额',
          dataIndex: 'allAmount',
          width: 100,
          scopedSlots: { customRender: 'allAmount' },
        },

        {
          title: '付款银行',
          dataIndex: 'PayBank',
          width: 100,
        },

        {
          title: '备注',
          dataIndex: 'remark',

        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',  // 这里设置了固定在右侧
          scopedSlots: { customRender: 'action' },
          width: 147
        },
      ],
      searchForm: { page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 50 },
      loading: false,
      items: [],
      exportItems: [],
      visible: false,
      targetItem: {},
      form: {},
      total_amount: 0, // 添加这一行来存储总金额
      supplierFilter: '', // 添加供应商筛选值
      defaultMonth: this.getLastMonth(), // 添加默认月份（上个月）
    };
  },
  computed: {
    // 获取所有不重复的供应商名称
    supplierOptions() {
      const suppliers = new Set();
      this.items.forEach(item => {
        if (item.supplier_name) {
          suppliers.add(item.supplier_name);
        }
      });
      return Array.from(suppliers);
    },

    // 过滤后的数据
    filteredItems() {
      if (!this.supplierFilter) {
        return this.items;
      }
      return this.items.filter(item =>
        item.supplier_name === this.supplierFilter
      );
    },

    // 计算过滤后的总金额
    filteredTotalAmount() {
      let total = 0;
      this.filteredItems.forEach(item => {
        if (!item.is_void) {
          total += this.calculate(item.payment_account_items);
        }
      });
      return total;
    }
  },
  methods: {
    // 获取上个月的方法
    getLastMonth() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    },
    // 供应商选择变更
    handleSupplierChange(value) {
      this.supplierFilter = value;
    },
    onChangePicker(a, b) {
      if (a == null) {
        this.searchForm.start_date = a;
        this.searchForm.end_date = a;
        this.search();
        return;
      }
      const { first_day1, last_day1 } = ChangePicker(a, b)
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;
      this.search();
    },


    onExport() {
      import("../../../utils/xlsx.js").then((excel) => {
        //tHeader 为导出后的表头
        let tHeader = [], filterVal = [], list = []
        tHeader = ["单号", "供应商", "经手人", "录入时间", "发生日期", "付款银行", "优惠金额", "合计金额", "备注",];
        filterVal = ["number", "supplier_name", "handler_name", "create_time", "handle_time", "PayBank", "discount_amount", "allAmount", "remark",];
        list = this.exportItems
        list.reverse();
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `付款` + this.getCurrentDate(),
          autoWidth: true,
          bookType: "xlsx",
        });
      });

    },

    getCurrentDate() {
      let today = new Date();
      let year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要+1，并且补0到两位数
      let day = today.getDate().toString().padStart(2, '0'); // 补0到两位数
      let formattedDate = `${year}${month}${day}`; // 拼接年月日
      return formattedDate;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    calculate(dataList) {
      let allAmount = 0
      ;(dataList || []).forEach(item => {
        allAmount = allAmount + parseFloat(item.payment_amount)
      })
      return allAmount
    },
    initialize() {
      // 设置初始搜索条件为上个月
      const { first_day1, last_day1 } = ChangePicker(this.defaultMonth);
      this.searchForm.start_date = first_day1;
      this.searchForm.end_date = last_day1;

      this.list();
    },
    list() {
      this.loading = true;
      paymentOrdersList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;

        this.exportItems = []
        this.total_amount = 0; // 重置总金额
        this.items.forEach(item => {
          const obj = item
          const itemAmount = this.calculate(item.payment_account_items);
          obj.allAmount = itemAmount
          obj.discount_amount = parseFloat(item.discount_amount)
          obj.PayBank = item.payment_account_items.length > 0 ? item.payment_account_items[0].account_name : ''

          // 只有未作废的记录才计入总和
          if (!item.is_void) {
            this.total_amount += itemAmount;
          }

          this.exportItems.push(obj)
        })
      }).finally(() => {
        this.loading = false;
      });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
      this.list();
    },

    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    handelAdd(item) {
      this.$router.push({ path: '/finance/payment_create' });
    },
    detial(item) {
      this.$router.push({ path: '/finance/payment_detail', query: { id: item.id } });
    },
    voidItem(item) {
      paymentOrdersVoid({ id: item.id }).then(() => {
        this.$message.success('作废成功');
        this.list();
      }).catch(() => {
      });
    },
  },
  mounted() {
    this.initialize();
  },
}
</script>
